/**
 * Split the phone number into groups of 4 digits
 *
 * @param {string|number} number
 * @returns {string}
 */
const splitNumber = number =>
  String(number)
    .match(/.{4}/g)
    .join(' ');

export default splitNumber;
